var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddComentEnterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.444,
    height: 14.491,
    viewBox: "0 0 12.444 14.491",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share_1_",
    "data-name": "share (1)",
    transform: "rotate(180 24.3 7.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2791",
    "data-name": "Group 2791",
    transform: "translate(36.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    fill: "black",
    d: "M48.419 4.229L44.376.18a.615.615 0 1 0-.87.869l3 3.006h-6.154a4.205 4.205 0 0 0-4.2 4.185v5.635a.614.614 0 1 0 1.229 0V8.243a2.974 2.974 0 0 1 2.968-2.958H46.5l-2.995 2.994a.615.615 0 0 0 .87.869L48.419 5.1a.614.614 0 0 0 0-.871z",
    "data-name": "Path 825",
    transform: "translate(-36.155)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddComentEnterIcon);
export default __webpack_public_path__ + "static/media/AddComentEnterIcon.abf00b27dfc4eedd124b58338faad142.svg";
export { ForwardRef as ReactComponent };